import { createContext, useContext, useEffect, useState } from "react";
import { io, Socket } from "socket.io-client";
import { AuthContext } from "./auth.context";
import { ToasterContext } from "./toaster.context";

type ISocketContext = {
    connected: boolean;
    emit: (ev: string, ...args: any[]) => void;
    on: (ev: string, listener: (...args: any[]) => void) => void;
    off: (ev: string) => void;
    join: (group: string) => void;
    leave: (group: string) => void;
};

//@ts-ignore
export const SocketContext = createContext<ISocketContext>(undefined);

const socket = io(process.env.REACT_APP_SOCKET_URL, {autoConnect: false});

export function SocketProvider({children}: {
    children: React.ReactNode;
}) {
    const auth = useContext(AuthContext);
    const toaster = useContext(ToasterContext);
    // const [socket, setSocket] = useState(io(process.env.REACT_APP_SOCKET_URL, {autoConnect: false}));
    const [connected, setConnected] = useState(false);

    function emit(ev: string, ...args: any[]) {

        socket.emit(ev, auth.token ? `Bearer ${auth.token}` : null, ...args);
    }

    function on(ev: string, listener: (...args: any[]) => void) {
        socket.on(ev, listener);
    }

    function off(ev: string) {
        socket.removeAllListeners(ev);
    }

    function join(group: string) {
        emit("join-group", group);
    }

    function leave(group: string) {
        emit("leave-group", group);
    }

    useEffect(() => {

        socket.on("connect", () => {
            console.log("🕸️🔌✅");
            setConnected(true);
        });

        socket.on("disconnect", () => {
            console.log("🕸️🔌❌");
            setConnected(false);
        });

        socket.connect();

        const unloadcb = () => {
            if (auth.user) {
                leave(`user-${auth.user.id}`);
            }
        }

        window.addEventListener("beforeunload", unloadcb);

        return () => {
            window.removeEventListener("beforeunload", unloadcb);

            socket.removeAllListeners("connect");
            socket.removeAllListeners("disconnect");

            socket.disconnect();
            console.log("🕸️🔌♻️");
            setConnected(false);
        }
    }, []);

    useEffect(() => {
        if (!auth.user) return;
        const id = auth.user.id;
        join(`user-${id}`);

        return () => {
            leave(`user-${id}`);
        }
    }, [auth.user]);

    return (
        <SocketContext.Provider value={{
            connected,
            emit,
            on,
            off,
            join,
            leave
        }}>
            {children}
        </SocketContext.Provider>
    );
}